import input from "./input";
import Vue from "vue";

const directives = { input };

Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});
